import useQuery from './useQuery';

/** M9 slice 3 (#164): per-event in-app/email notification preferences for a
 * seller. Returns `[{ event, in_app, email }]`; the page upserts via PUT. */
function useNotificationPrefsQuery(sellerId, params) {
  return useQuery('/notifications/preferences/', {
    enabled: Boolean(sellerId),
    queryParams: { seller: sellerId },
    staleTime: 30 * 1000,
    ...params,
  });
}

export default useNotificationPrefsQuery;
